import {Department} from '../types/types';

export const departmentList: Department[] = [
  {
    clientDepartmentId: '12345',
    name: 'HR',
    description: 'Handles human resources',
    isDefault: true,
    editedBy: 'admin',
    editedOn: '2024-10-08',
    clientBranchId: '2de094e8-3757-437c-91e7-f7feb205743f',
    clientBranchName: 'Main Branch',
    expanded: true,
    project: [],
  },
  {
    clientDepartmentId: '12346',
    name: 'Finance',
    description: 'Manages financial operations',
    isDefault: false,
    editedBy: 'admin',
    editedOn: '2024-10-08',
    clientBranchId: '2de094e8-3757-437c-91e7-f7feb205743f',
    clientBranchName: 'Finance Branch',
    expanded: false,
    project: [],
  },
  {
    clientDepartmentId: '12347',
    name: 'IT',
    description: 'Handles IT infrastructure',
    isDefault: true,
    editedBy: 'admin',
    editedOn: '2024-10-08',
    clientBranchId: '2de094e8-3757-437c-91e7-f7feb205743f',
    clientBranchName: 'IT Branch',
    expanded: true,
    project: [],
  },
  {
    clientDepartmentId: '12348',
    name: 'Marketing',
    description: 'Promotes products and services',
    isDefault: false,
    editedBy: 'admin',
    editedOn: '2024-10-08',
    clientBranchId: '5f742584-4ed1-49fb-994c-a51cd1bd42b5',
    clientBranchName: 'Marketing Branch',
    expanded: false,
    project: [],
  },
  {
    clientDepartmentId: '12349',
    name: 'Sales',
    description: 'Manages sales operations',
    isDefault: true,
    editedBy: 'admin',
    editedOn: '2024-10-08',
    clientBranchId: '5f742584-4ed1-49fb-994c-a51cd1bd42b5',
    clientBranchName: 'Sales Branch',
    expanded: true,
    project: [],
  },
  {
    clientDepartmentId: '12350',
    name: 'Operations',
    description: 'Oversees day-to-day operations',
    isDefault: false,
    editedBy: 'admin',
    editedOn: '2024-10-08',
    clientBranchId: '5f742584-4ed1-49fb-994c-a51cd1bd42b5',
    clientBranchName: 'Operations Branch',
    expanded: false,
    project: [],
  },
  {
    clientDepartmentId: '12351',
    name: 'Customer Service',
    description: 'Handles customer interactions',
    isDefault: true,
    editedBy: 'admin',
    editedOn: '2024-10-08',
    clientBranchId: '5f742584-4ed1-49fb-994c-a51cd1bd42b5',
    clientBranchName: 'Customer Service Branch',
    expanded: true,
    project: [],
  },
];

export const branchList = [
  {
    clientBranchId: '5f742584-4ed1-49fb-994c-a51cd1bd42b5',
    name: 'Client Branch 1',
    description: 'Description for Client Branch 1',
  },
  {
    clientBranchId: '2de094e8-3757-437c-91e7-f7feb205743f',
    name: 'Client Branch 2',
    description: 'Description for Client Branch 2',
  },
];
